import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import PageHeader from './PageHeader';
import styled from 'styled-components';
import DynamicTable from './DynamicTable';
import {removeEmpty} from '../helpers/object';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Wrapper = styled.div`
  min-width: 600px;
  margin: 0px 16px;
  flex-grow: 1;
`;

export default class PageWithTable extends PureComponent {
  static propTypes = {
    actionButton: PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
    }),
    customButton: PropTypes.shape({
      title: PropTypes.string,
      action: PropTypes.func,
      fetching: PropTypes.bool
    }),
    filters: PropTypes.arrayOf(
      PropTypes.shape({
        keyName: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        data: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.any,
          })
        ),
        fetching: PropTypes.bool,
        getData: PropTypes.func,
      })
    ),
    filterByDatePlaceholder: PropTypes.string,
    filterByDate: PropTypes.bool,
    filterByDateKeyName: PropTypes.string,
    data: PropTypes.array,
    dataTotalPages: PropTypes.number,
    dataFetching: PropTypes.bool,
    dataColumns: PropTypes.array.isRequired,
    getData: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      filters: {},
      currentPage: 1,
      order: undefined,
    };
  }

  componentDidMount() {
    //if (!this.props.data) {
      this.loadData();
    //}
  }

  onFilter = (fieldName, value) => {
    this.setState({
      filters: {...this.state.filters, [fieldName]: value},
      currentPage: 1
    }, () => this.loadData());
  }

  onColumnSort = order => {
    this.setState({order, currentPage: 1}, () => this.loadData());
  }

  loadData() {
    const {
      currentPage,
      order,
    } = this.state;
    const {query, ...filters} = this.state.filters;

    const filter = removeEmpty({
      ...filters
    });

    this.props.getData(removeEmpty({
      page: currentPage,
      query,
      filter: Object.keys(filter).length > 0 ? filter : undefined,
      order,
    }));
  }

  onLoadMore = () => {
    const currentPage = this.state.currentPage + 1;
    if (currentPage <= this.props.dataTotalPages) {
      this.setState({currentPage}, () => this.loadData());
    }
  }

  render() {
    const {
      data,
      dataColumns,
      dataFetching,
      filters,
      filterByDate,
      filterByDateKeyName,
      filterByDatePlaceholder,
      actionButton,
      customButton,
      permissions,
      ...otherProps
    } = this.props;
    return (
      <Container>
        <PageHeader
          actionButton={permissions && permissions.create && actionButton}
          customButton={customButton}
          filterByDatePlaceholder={filterByDatePlaceholder}
          filterByDate={filterByDate}
          filterByDateKeyName={filterByDateKeyName}
          filters={filters}
          onFilter={this.onFilter}
        />
        <Wrapper>
          <DynamicTable
            columns={dataColumns}
            data={data}
            fetching={dataFetching}
            onLoadMore={this.onLoadMore}
            onSortChanged={this.onColumnSort}
            permissions={permissions}Wrapper
            {...otherProps}
          />
        </Wrapper>
      </Container>
    );
  }
}